<template>
  <b-navbar
    type="dark"
    variant="primary"
    class="mb-2"
  >
    <b-navbar-brand>Administration DOMICIALIZ</b-navbar-brand>
    <b-navbar-nav class="mr-auto">
      <b-nav-item
        :to="{ name: 'admin-dom-dossiers' }"
        :active="active === 'dossiers'"
      >
        Dossiers
      </b-nav-item>
      <b-nav-item
        v-if="admin && admin.superadmin"
        :to="{ name: 'admin-dom-utilisateurs' }"
        :active="active === 'utilisateurs'"
      >
        Utilisateurs
      </b-nav-item>
      <b-nav-item
        v-if="admin && admin.superadmin"
        :to="{ name: 'admin-dom-formules' }"
        :active="active === 'formules'"
      >
        Formules
      </b-nav-item>
      <b-nav-item
        v-if="admin && admin.superadmin"
        :to="{ name: 'admin-dom-documents-requis' }"
        :active="active === 'documents-requis'"
      >
        Documents
      </b-nav-item>
      <b-nav-item
        v-if="admin && admin.superadmin"
        :to="{ name: 'admin-dom-formes-juridiques' }"
        :active="active === 'formes-juridiques'"
      >
        Formes juridiques
      </b-nav-item>
      <b-nav-item
        v-if="admin && admin.superadmin"
        :to="{ name: 'admin-dom-templates' }"
        :active="active === 'templates'"
      >
        Templates
      </b-nav-item>
      <b-nav-item
        :to="{ name: 'admin-dom-profil' }"
        :active="active === 'profil'"
      >
        Mon profil
      </b-nav-item>
    </b-navbar-nav>
    <b-navbar-nav class="ml-auto align-items-center">
      <span
        v-if="admin"
        class="text-white mr-2"
      >
        {{ admin.prenom }} {{ admin.nom }}
        <b-badge
          v-if="admin.superadmin"
          variant="warning"
          class="ml-1"
        >
          superadmin
        </b-badge>
      </span>
      <b-button
        size="sm"
        variant="outline-light"
        @click="logout"
      >
        Déconnexion
      </b-button>
    </b-navbar-nav>
  </b-navbar>
</template>

<script>
import {
  BNavbar, BNavbarBrand, BNavbarNav, BNavItem, BButton, BBadge,
} from 'bootstrap-vue'

export default {
  components: {
    BNavbar, BNavbarBrand, BNavbarNav, BNavItem, BButton, BBadge,
  },
  props: {
    active: { type: String, default: '' },
  },
  data() {
    return { admin: null }
  },
  created() {
    const raw = localStorage.getItem('domAdminData')
    if (raw) this.admin = JSON.parse(raw)
  },
  methods: {
    logout() {
      localStorage.removeItem('domAdminToken')
      localStorage.removeItem('domAdminData')
      this.$router.push({ name: 'admin-dom-login' })
    },
  },
}
</script>
